import React from 'react';

interface ICTAButton {
  linkData: {
    linkUrl?: string;
    openInNewTab?: boolean;
    linkText?: string;
  };
  actionClick: () => void;
  actionKeyUp: any;
  labelText: string;
}

const CTAButton: React.FC<ICTAButton> = (props) => {
  return (
    <div className='mfrm-financing-modal__button-container'>
        {props.linkData && (
            <a
                href={props.linkData.linkUrl}
                target={props.linkData.openInNewTab ? '_blank' : '_self'}
                onClick={() => props.actionClick()}
                onKeyUp={() => props.actionKeyUp()}
                className='mfrm-financing-modal__button'
            >
                {props.linkData.linkText}
            </a>
        )}
      <p className="label-text">
          {props.labelText}
      </p>
    </div>
  );
};

export default CTAButton;
